import React, {memo} from "react";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {NESTED_NODE_HORIZONTAL_MARGIN} from "../../stylingConstants";
import styled from '@emotion/styled';
import {Control} from "rete-react-render-plugin";

const StyledMainContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 0px;
`;

const StyledRemoveButtonContainerDiv = styled.div`
  margin-left: auto;
  position: relative;
`;

const StyledRemoveButtonControlWrapperDiv = styled.div`
  position: absolute;
  top: -36px;
  right: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const StyledQuestionControlContainerDiv = styled.div`
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
  margin-right: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const TextQuestion = ({controls, bindControl, isNodeCollapsed}) => {

    if (controls.length === 0) return null;

    const questionUUID = controls[0].key.split("_")[0];
    const removeControl = controls.find(control => control.key.includes(SequenceComponentHelper.getTextQuestionRemoveButtonKey(questionUUID)));
    const questionControl = controls.find(control => control.key.includes(SequenceComponentHelper.getTextQuestionQuestionKey(questionUUID)));

    return (
        <StyledMainContainerDiv>

            {/** REMOVE BTN */}
            {!isNodeCollapsed &&
                <StyledRemoveButtonContainerDiv>
                    <StyledRemoveButtonControlWrapperDiv>
                        <Control key={removeControl.key} control={removeControl} innerRef={bindControl}/>
                    </StyledRemoveButtonControlWrapperDiv>
                </StyledRemoveButtonContainerDiv>
            }

            {/** QUESTION CONTROL */}
            <StyledQuestionControlContainerDiv>
                <Control key={questionControl.key} control={questionControl} innerRef={bindControl}/>
            </StyledQuestionControlContainerDiv>
        </StyledMainContainerDiv>
    );
}

export default memo(TextQuestion);